export const DeveloperIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="currentColor"
      {...props}
    >
      <g clipPath="url(#clip0_53_3433)">
        <path d="M18 6V4.3395L5.37525 0H4.70175L0 4.55775V6H3V16.5H0V18H11.25V16.5H8.25V6H15V11.655C15 12.4815 15.423 13.2218 16.1047 13.5885C16.3485 13.7198 16.5 13.9733 16.5 14.25C16.5 14.6632 16.164 15 15.75 15C15.336 15 15 14.6632 15 14.25H13.5C13.5 15.4905 14.5095 16.5 15.75 16.5C16.9905 16.5 18 15.4905 18 14.25C18 13.4213 17.5462 12.6615 16.815 12.2677C16.6238 12.1643 16.5 11.9242 16.5 11.655V6H18ZM6.75 15.0645L4.8105 13.125L6.75 11.1855V15.0645ZM4.5 11.3145V7.4355L6.4395 9.375L4.5 11.3145ZM4.5 14.9355L6.0645 16.5H4.5V14.9355ZM6.75 7.5645L5.1855 6H6.75V7.5645ZM2.214 4.5L5.2605 1.5465L13.8517 4.5H2.214Z" />
      </g>
      <defs>
        <clipPath id="clip0_53_3433">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
